import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ReactMic } from 'react-mic-plus';
import axios from 'axios';
import { push, goBack } from 'connected-react-router';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import SecundaryButton from '../../components/SecundaryButton/SecundaryButton';
import { setSearchTerm, clearSearchTerm, getSuggestions, clearSearch } from '../../redux/actions/result.action';
import { setTextToSpeak, loadContentForPage, setData } from '../../redux/actions/text.action';

import './InputSpeech.scss';

//icon
import microIcon from '../../assets/micro.png';
import keyboardIcon from '../../assets/keyboard_gray.png';

//text
import assistantText from '../../assets/text/text.json';
/**
 * Home page component
 */

const issueTokenURL = "https://westeurope.api.cognitive.microsoft.com/sts/v1.0/issuetoken";
const ocpapimsubKey = "ff2986e3bb594763b15dff12edb9939d";

class InputSpeech extends Component<{ navigateTo: any, setText: any, term: any, speak: any, setCurrentpage: any, searchTerm: string, setData: any, back: any }, { record: boolean, currentFile: any, searchTerm: string }> {

    constructor(props: any) {
        super(props);
        this.state = {
            record: false,
            currentFile: null,
            searchTerm: ""
        }
    }

    startRecording() {
        this.setState({ record: true });
    }
    stopRecording() {
        this.setState({ record: false });
    }

    speech2Text(wav: any) {
        axios.post(issueTokenURL, {}, {
            headers: {
                "Ocp-Apim-Subscription-Key": ocpapimsubKey
            }
        }).then((result: any) => {
            axios.post('https://westeurope.stt.speech.microsoft.com/speech/recognition/conversation/cognitiveservices/v1?language=de-DE&format=detailed', wav, {
                method: 'POST',
                headers: {
                    "Content-Type": "audio/wav; codecs=audio/pcm; samplerate=16000",
                    "Authorization": "Bearer " + result.data,
                }
            }).then((response) => {
                if (response.data.NBest) {
                    this.setState({ searchTerm: response.data.NBest[0].MaskedITN });
                    this.props.setText(this.props.searchTerm + " " + this.state.searchTerm);
                    this.props.speak(this.props.searchTerm + this.state.searchTerm);
                    this.props.navigateTo('/inputspeechvalidation')
                }
            });
        }).catch(err => console.log(err));
    }

    onStop(blobObject: any) {
        this.speech2Text(blobObject.blob);
    }

    renderBody() {
        return (
            <div className="inputspeech-container">
                <div className={"inputspeech-action-container " + (this.state.record ? "active" : "")} onClick={() => {
                    this.props.setData();
                    if (!this.state.record) {
                        this.startRecording()
                    } else {
                        this.stopRecording()
                    }
                }}>
                    <img src={microIcon} className="inputspeech-action-icon" alt="speech-icon" />
                </div>
                <ReactMic
                    record={this.state.record}
                    className="sound-wave"
                    onStop={this.onStop.bind(this)}
                    strokeColor="#000000"
                    backgroundColor="#f3b633" />
                <SecundaryButton text="Lieber schreiben" icon={keyboardIcon} action={() => { this.props.navigateTo('/inputtext') }}></SecundaryButton>
            </div>
        )
    }
    onData(recordedBlob: any) {
        console.log('chunk of real-time data is: ', recordedBlob);
    }

    replaceThis(text: string, term: string) {
        return text.replace('%input', term);
    }

    /**
     * Main render method of component
     */
    render() {
        return (
            <div className="inputspeech">
                <PageTemplate assistantLine1={assistantText.sprachMethode.Assistant.line1} assistantLine2={assistantText.sprachMethode.Assistant.line2} body={this.renderBody()} page="sprachMethode" text={['']} customBack={() => {
                    this.stopRecording();
                    this.props.back();
                }} />
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        searchTerm: state.result.searchTerm
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        navigateTo(path: string) {
            dispatch(push(path));
        },
        setText(term: string) {
            dispatch(clearSearchTerm());
            dispatch(setSearchTerm(term));
            dispatch(getSuggestions(term));
        },
        speak(text: string) {
            dispatch(setTextToSpeak(text));
        },
        setCurrentpage() {
            dispatch(loadContentForPage("sprachMethode"));
        },
        setData() {
            dispatch(setData(null));
        },
        back() {
            dispatch(goBack())
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InputSpeech);